import React from 'react';
import { Route } from 'react-router-dom';
import SignIn from '../signIn';
import SignUp from '../signUp';
import OnBoard from '../onBoard';
import LoggedIn from '../loggedIn';
import 'grommet-css'

const App = () => (
  <div>
    <main>
      <Route exact path="/" component={SignIn} />
      <Route exact path="/signup" component={SignUp} />
      <Route path="/setup" component={OnBoard} />
      <Route path="/app" component={LoggedIn} />
    </main>
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./src/containers/app/index.js